<template>
    <component
        :is="component"
        :href="href"
        :class="[variant, btnSmall ? 'btn_small' : '']"
        :type="type"
        :src="src"
        :icon="icon"
        :alt="alt"
        :form="form"
        :to="to"
        @click="btnClick"
        :disabled="disabled"
        >
        <img class="button_img" v-if="src" :src="src" :alt="alt" />
        <fa v-if="icon" :icon="[iconType, icon]" />
        <slot />
    </component>
</template>

<script>
import { computed } from 'vue'
export default {
    name: 'BaseButton',
    emits: ['btnClick'],
    props: {
        href: {
            type: String,
            required: false,
        },
        to: {
            type: String,
            required: false,
        },
        variant: {
            type: String,
        },
        type: {
            type: String,
        },
        src: {
            type: String,
            required: false,
        },
        iconType: {
            type: String,
            default: 'fal',
        },
        icon: {
            type: String,
            required: false,
        },
        alt: {
            type: String,
            required: false,
        },
        form: {
            type: String,
            default: '',
        },
        btnSmall: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    },
    setup(props, context) {
        const component = computed(() => {
            if (props.href !== undefined) {
                return 'a'
            }
            return 'button'
        })
        const btnClick = () => {
            context.emit('btnClick')
        }
        return {
            component,
            btnClick,
        }
    },
}
</script>

<style scoped>
.btn {
    @apply flex rounded items-center justify-center text-sm h-8 cursor-pointer text-center md:px-6 px-6;
}
.btn_small {
    @apply h-8 text-sm pl-[1.125rem] pr-[1.375rem];
}
.btn_label {
    @apply flex rounded-full h-4 items-center justify-center text-xs px-3;
}
.blue {
    @apply bg-blue-500 text-white;
}
.gray {
    @apply bg-gray-100 text-gray-300 border border-gray-200;
}
.gray-outline {
    @apply border border-gray-200 text-gray-300 bg-transparent hover:bg-gray-500 hover:text-white transition-all;
}
.button_img {
    @apply ltr:mr-2 rtl:ml-2;
}
.link-blue {
    @apply text-blue-500 text-base cursor-pointer justify-start;
}
.btn-link {
    @apply text-dark-100 text-[0.8125rem] cursor-pointer border-b border-dark-100;
}
.blue-outline {
    @apply border border-blue-500 text-blue-500 bg-transparent hover:bg-blue-500 hover:text-white transition-all;
}
.blue-outline-bg {
    @apply border border-blue-500 text-blue-500 bg-white dark:bg-dark-100 hover:bg-blue-500 dark:hover:bg-blue-500 hover:text-white transition-all;
}
.btn img {
    @apply w-6 h-6;
}
.btn svg {
    @apply text-2xl text-current ltr:mr-1 rtl:ml-1;
}
.btn-white{
    @apply bg-white text-sm font-medium text-gray-300 border border-gray-200 rounded px-3 py-[0.4375rem] leading-4 h-auto;
}
.btn-blue{
    @apply bg-blue-500 text-sm font-medium text-white rounded px-3 py-2 leading-4 h-auto flex
    items-center;
}
.btn-black{
    @apply bg-black-900 flex rounded items-center justify-center text-sm h-auto cursor-pointer text-center px-2 py-1 text-white font-medium;
}
.btn-addLabel{
    @apply bg-transparent p-0 text-gray-500 text-sm;
}
.btn-outline-black{
   @apply bg-transparent border border-black-500 rounded px-3 py-2.5 h-8 text-sm text-black-500 font-medium;
}
.btn-black[disabled]{
    @apply cursor-not-allowed opacity-50;
}
.btn-blue[disabled]{
    @apply cursor-not-allowed opacity-50;
}
</style>
